/** @jsxImportSource @emotion/react */

import { useSelector } from 'react-redux';

import LoadingAnimation from '../components/LoadingAnimation';
import { requestsSelectors } from '../requests/reducer';

const UserManagementLoadingAnimation = () => {
  const getInvitationsInProgress = useSelector(requestsSelectors.getInvitationsInProgress);
  const invitationInProgress = useSelector(requestsSelectors.invitationInProgress);
  const loadInitialUsersInProgress = useSelector(requestsSelectors.loadInitialUsersInProgress);
  const loadInitialDeactivatedUsersInProgress = useSelector(requestsSelectors.loadInitialDeactivatedUsersInProgress);
  const searchSortUsersInProgress = useSelector(requestsSelectors.searchSortUsersInProgress);
  const updateUserInProgress = useSelector(requestsSelectors.updateUserInProgress);
  const toggleUserStatusInProgress = useSelector(requestsSelectors.toggleUserStatusInProgress);

  return (
    <div
      css={{
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        visibility:
          getInvitationsInProgress ||
          invitationInProgress ||
          loadInitialUsersInProgress ||
          loadInitialDeactivatedUsersInProgress ||
          searchSortUsersInProgress ||
          updateUserInProgress ||
          toggleUserStatusInProgress
            ? 'visible'
            : 'hidden'
      }}
    >
      <LoadingAnimation size='l' />
    </div>
  );
};

export default UserManagementLoadingAnimation;
